import React, {useEffect} from "react";
import Routes from "./routes";
import {useLocation} from "react-router-dom";
import ReactGA from "react-ga";
import {useDispatch} from "react-redux";
import {fetchCities} from "./redux/actions";

window['isMobile'] = window.screen.width <= 1024;
const subdomain = window.location.host.split('.')[0];
const track = ["italia", "europa"].includes(subdomain) ? "UA-171158249-2" : "UA-171158249-1";

ReactGA.initialize(track);

document.body.className = '__'+subdomain;

function App() {

    const dispatch = useDispatch();

    useEffect(() => {

        async function fetchData() {

            await fetchCities({
                country_id: ['italia', 'europa'].includes(subdomain) ? 2 : 1
            }, dispatch);
        }

        // noinspection JSIgnoredPromiseFromCall
        fetchData();

    }, [subdomain])

    const location = useLocation();

    useEffect(() => {
        ReactGA.pageview(location.pathname);
    }, [location]);

    return (
        <React.Fragment>
            <Routes/>
        </React.Fragment>
    );
}

export default App;
